export const apiVehicleRoutes = {
  routeVehicle: 'driver/vehicle/',
};